import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  DeleteButton,
  Filter,
  SearchInput,
  SelectInput,
  TopToolbar,
  ExportButton,
  ChipField,
  FunctionField,
} from 'react-admin';

const paymentStatusChoices = [
  { id: 'PENDING', name: 'Ожидает' },
  { id: 'PROCESSING', name: 'Обрабатывается' },
  { id: 'COMPLETED', name: 'Завершен' },
  { id: 'FAILED', name: 'Неудачен' },
  { id: 'CANCELLED', name: 'Отменен' },
  { id: 'REFUNDED', name: 'Возвращен' },
];

const paymentMethodChoices = [
  { id: 'CARD', name: 'Карта' },
  { id: 'CRYPTO', name: 'Криптовалюта' },
];

const paymentProviderChoices = [
  { id: 'STRIPE', name: 'Stripe' },
  { id: 'COINBASE', name: 'Coinbase' },
];

const PaymentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <SelectInput
      source="status"
      choices={paymentStatusChoices}
      label="Статус"
    />
    <SelectInput
      source="paymentMethod"
      choices={paymentMethodChoices}
      label="Способ оплаты"
    />
    <SelectInput
      source="provider"
      choices={paymentProviderChoices}
      label="Провайдер"
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

const StatusChip = ({ record }: any) => {
  const statusChoice = paymentStatusChoices.find(choice => choice.id === record.status);
  const getColor = (status: string) => {
    switch (status) {
      case 'PENDING': return 'warning';
      case 'PROCESSING': return 'info';
      case 'COMPLETED': return 'success';
      case 'FAILED': return 'error';
      case 'CANCELLED': return 'default';
      case 'REFUNDED': return 'secondary';
      default: return 'default';
    }
  };
  
  return (
    <ChipField 
      record={{ value: statusChoice?.name || record.status }} 
      source="value" 
      color={getColor(record.status)}
    />
  );
};

const AmountField = ({ record }: any) => (
  <span>{record.amount?.toFixed(2)} {record.currency?.toUpperCase()}</span>
);

const MethodChip = ({ record }: any) => {
  const methodChoice = paymentMethodChoices.find(choice => choice.id === record.paymentMethod);
  return <ChipField record={{ value: methodChoice?.name || record.paymentMethod }} source="value" />;
};

const ProviderChip = ({ record }: any) => {
  const providerChoice = paymentProviderChoices.find(choice => choice.id === record.provider);
  return <ChipField record={{ value: providerChoice?.name || record.provider }} source="value" />;
};

export const PaymentList = () => (
    <List
      filters={<PaymentFilter />}
      actions={<ListActions />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      perPage={25}
    >
    <Datagrid>
      <TextField source="id" label="ID транзакции" />
      
      {/* Клиент */}
      <TextField source="user.name" label="Клиент" />
      <TextField source="user.email" label="Email клиента" />
      
      {/* Заказ */}
      <TextField source="order.id" label="ID заказа" />
      <TextField source="order.supplement.name" label="Товар" />
      
      {/* Финансовые данные */}
      <FunctionField 
        label="Сумма"
        render={(record: any) => <AmountField record={record} />}
      />
      <FunctionField 
        label="Способ оплаты"
        render={(record: any) => <MethodChip record={record} />}
      />
      <FunctionField 
        label="Провайдер"
        render={(record: any) => <ProviderChip record={record} />}
      />
      
      {/* Статус */}
      <FunctionField 
        label="Статус"
        render={(record: any) => <StatusChip record={record} />}
      />
      <TextField source="failureReason" label="Причина ошибки" />
      
      {/* Провайдер данные */}
      <TextField source="providerTransactionId" label="ID у провайдера" />
      
      {/* Даты */}
      <DateField source="createdAt" label="Создана" />
      <DateField source="updatedAt" label="Обновлена" />
      
      <ShowButton />
      <DeleteButton />
    </Datagrid>
    </List>
);
